module.exports = __webpack_public_path__ + "img/feature-02.bf8684c4.png";